import React, { Component } from "react"
import "./popup.scss"

import "./SubscribeNewsletterForm.scss"
import footerSubmit from "../assets/images/Icons/arrow.svg"
import PopupImage from "../assets/images/popup-image.jpg"

function encode(data) {
  return Object.keys(data)
    .map((key) => encodeURIComponent(key) + "=" + encodeURIComponent(data[key]))
    .join("&")
}

const Modal = ({ handleClose, show, children }) => {
  const showHideClassName = show ? "modal active" : "modal"
  return (
    <div className={showHideClassName}>
      <section className="modal__wrapper">{children}</section>
      <button className="modal__close" onClick={handleClose} />
    </div>
  )
}

function setCookie(name, value, days) {
  let expires = ""
  if (days) {
    let date = new Date()
    date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000)
    expires = "; expires=" + date.toUTCString()
  }
  document.cookie = name + "=" + (value || "") + expires + "; path=/"
}

function getCookie(name) {
  let nameEQ = name + "="
  let ca = document.cookie.split(";")
  for (let i = 0; i < ca.length; i++) {
    let c = ca[i]
    while (c.charAt(0) === " ") c = c.substring(1, c.length)
    if (c.indexOf(nameEQ) === 0) return c.substring(nameEQ.length, c.length)
  }
  return false
}

class NewsletterPopup extends Component {
  state = {
    show: false,
    result: "",
    email: "",
    first_name: "",
    msg: "",
  }

  hidePopup = () => {
    this.setState({ show: false })
  }

  handleChange = (e) => {
    this.setState({ [e.target.name]: e.target.value })
  }

  handleSubmit = (e) => {
    e.preventDefault()
    const form = e.target
    fetch("/?no-cache=1", {
      method: "POST",
      headers: { "Content-Type": "application/x-www-form-urlencoded" },
      body: encode({
        "form-name": form.getAttribute("name"),
        ...this.state,
      }),
    })
      .then(() => this.setState({ show: false }))
      .catch((error) => this.setState({ result: "fail", msg: error }))
  }

  componentDidMount() {
    if (getCookie("newsletter-popup")) return

    setTimeout(() => {
      this.setState({ show: true }, () => {
        setCookie("newsletter-popup", "done", 365)
      })
    }, 4000)
  }

  render() {
    let { show, email, first_name } = this.state
    return (
      <>
        <div
          className={
            show ? "popup popup--newsletter active" : "popup popup--newsletter"
          }
        >
          <div className="popup__wrapper">
            <div className="popup__image">
              <img src={PopupImage} alt="Welcome to the new era of Oral Care" />
            </div>
            <div className="popup__content">
              <h4>Welcome to the new era of Oral Care</h4>
              <p>
                Sign up for 10% off your first order, exclusive competitions and
                product announcements
              </p>
              <form
                className="subscribe-newsletter-form"
                name="popup"
                method="post"
                data-netlify="true"
                data-netlify-honeypot="bot-field"
                onSubmit={this.handleSubmit}
              >
                <input type="hidden" name="form-name" value="contact" />
                <input
                  type="text"
                  name="first_name"
                  className="subscribe-newsletter-form__inp"
                  placeholder="First Name"
                  onChange={this.handleChange}
                  required
                />
                <input
                  type="text"
                  name="last_name"
                  className="subscribe-newsletter-form__inp"
                  placeholder="Last Name"
                  onChange={this.handleChange}
                  required
                />
                <input
                  type="email"
                  name="email"
                  className="subscribe-newsletter-form__inp"
                  placeholder="Email"
                  onChange={this.handleChange}
                  required
                />
                <button
                  type="submit"
                  className="subscribe-newsletter-form__submit"
                >
                  <img src={footerSubmit} />
                </button>
              </form>
              <span className="popup__close" onClick={this.hidePopup}>
                Next Time
              </span>
            </div>
          </div>
        </div>
      </>
    )
  }
}

export default NewsletterPopup
